import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

// Register necessary chart elements
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export const AttendanceChart = ({ chartData, onSegmentClick }) => {
  const { t } = useTranslation();
  const { labels, dataset1, dataset2 } = chartData;
  const translatedLabels = labels.map((day) => t(`days.${day}`));

  const data = {
    labels: translatedLabels, // days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    datasets: [
      {
        label: dataset1?.label, // "Present"
        data: dataset1?.data, // [20, 25, 23, 35, 28, 0, 0]
        backgroundColor: "#fdb714", // Yellow
        borderRadius: 4, // Border radius for top corners
        categoryPercentage: 0.7, // Controls the % of category width
        barPercentage: 0.6, // Controls the % of available width for bars
      },
      {
        label: dataset2?.label, // "Absent"
        data: dataset2?.data, // [5, 3, 4, 2, 3, 0, 0]
        backgroundColor: "#6F2E8F", // Purple
        borderRadius: 4, // Border radius for top corners
        categoryPercentage: 0.7, // Controls the % of category width
        barPercentage: 0.6, // Controls the % of available width for bars
      },
    ],
  };

  const options = {
    responsive: true,
    onClick: (event, elements, chart) => {
      if (elements.length > 0) {
        // const clickedElement = elements[0];
        // const index = clickedElement.index;
        // const label = chart.data.labels[index];
        // const value = chart.data.datasets[0].data[index];

        // Call the callback function with the clicked segment data
        if (onSegmentClick) {
          onSegmentClick();
        }
      }
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 12,
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Hide x-axis grid lines
        },
        title: {
          display: false,
        },
        border: {
          color: "#ccc",
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: true,
          drawTicks: false, // prevents ticks/grid lines extending past axis line
        },
        ticks: {
          precision: 0, // This ensures no decimal places
          maxTicksLimit: 5, // maximum 5 tick labels shown
          callback: function (value) {
            return value + "\u00A0\u00A0\u00A0\u00A0\u00A0"; // adds 5 non-breaking spaces after the label
          },
        },
        border: {
          display: false,
          dash: [3, 3], // dashed lines: 6px dash, 6px gap
        },
        title: {
          display: false,
        },
      },
    },
  };

  return <Bar data={data} options={options} height={200} />;
};
